import store from '@/store/index'
export let option = {
    lazy: true,
    tip: false,
    simplePage: true,
    searchShow: true,
    searchMenuSpan: 6,
    tree: true,
    border: true,
    index: true,
    selection: false,
    viewBtn: false,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    labelWidth: 150,
    searchLabelWidth: 100,
    menuWidth: 300,
    dialogClickModal: false,
    column: [
        {
            label: '代理商简称',
            prop: 'businessDeptIdList',
            type: 'select',
            filterable: true,
            multiple: true,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
            search: true,
            searchMultiple: true,
            searchClearable: true,
            defaultExpandAll: true,
            searchOrder: 1000,
            hide: true,
            dicData: store.getters.companies,
            props: {
                label: 'title',
                value: 'id',
            },
            display: false,
        },
        {
            label: '代理商简称',
            prop: 'deptName',
            search: false,
            // search: true,
            order: 999,
            maxlength: 50
        },
        {
            label: '绑定产品',
            prop: 'productName',
            search: false,
            order: 999,
            maxlength: 50
        },
        {
            label: '法大大绑定',
            prop: 'fascStatus',
            search: true,
            order: 999,
            type: 'select',
            maxlength: 50,
            dicData: [
                {
                    label: '未绑定',
                    value: 0,
                },
                {
                    label: '已绑定',
                    value: 1,
                },
            ],
            rules: [
                {
                    required: true,
                    message: '请输入绑定产品',
                    trigger: 'blur',
                }
            ],
        },
    ],
}

// 绑定法大大产品列表
export let boundProductFascOption = {
    lazy: true,
    tip: false,
    simplePage: true,
    searchShow: true,
    searchMenuSpan: 6,
    tree: true,
    border: true,
    index: true,
    selection: false,
    viewBtn: false,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    labelWidth: 150,
    searchLabelWidth: 100,
    menuWidth: 300,
    dialogClickModal: false,
    column: [
        {
            label: '产品类型',
            prop: 'productName',
            search: false,
            order: 999,
            maxlength: 50
        }
    ],
}